import React, { useState, useEffect } from "react";
import Select from "react-select";
import { PassingYear } from "../../constants/registration";
import { deviceType } from "../../utils/registrationUtils";
import { Field } from "formik";
import CommonModal from "../utils/commonModal";
import Loading from "../utils/loader";
import { connect } from "react-redux";
import { components } from "react-select";
import { MdOutlineArrowDropDown, MdOutlineArrowDropUp } from 'react-icons/md';
import CustomSelect from "./customSelect";
import {Prefill_Fields} from "../../constants/registration";

const CareersRegisterSingleSelect = (props) => {
  const { name, values, setFieldValue, validationSchema, errors, touched, handleBlur, searchBar } = props;

  const [optionsSlide, setOptionsSlide] = useState(false);
  const [overlayActive, setOverlayActive] = useState(false);
  const [open, setOpen] = useState(false);
  const [dropdownDatas, setDropdownDatas] = useState([]);
  const [show, setShow] = useState(false);
  const [searchData, setSearchData] = useState("")
  let signupUrl = window.location.pathname?.includes("/user/register");
  let completeProfileUrl = window.location.pathname?.includes("/user/complete-profile");

  const handleFocus = (event) => {
    setOverlayActive(true)
  };

  useEffect(() => {
    let dropdownsData = [];
    if (props.dropdownData?.values?.length > 0) {
      dropdownsData = props.dropdownData?.values?.map(
        (key) => {
          if (Array.isArray(props.dropdownData?.values?.[0]?.value)
            && props.dropdownData?.values?.[0]?.values?.length > 0) {
            return {
              label: key.label,
              options: key.values?.map((item) => ({
                id: item.id,
                label: item.value ?? item.label,
                domain_id: item.domain_id,
                group_id: item.group_id
              })),
            }
          } else {
            return {
              id: key.id ?? key.branch_id,
              label: key.value ?? key?.label,
              domain_id: key.domain_id,
            };
          }
        }
      );
    }
    setDropdownDatas(dropdownsData);
  }, [props.dropdownData?.values]);

  // Done for prefilling values in predictor cases.
  useEffect(() => {
    if(dropdownDatas && name === "target_year" && (signupUrl || completeProfileUrl)){
      PrefillDataForUrls();
    }
  }, [dropdownDatas, name])

  const handleCloseModal = () => {
    setShow(false);
    // handleBlur({ target: { name :name} });
    // left shift issue when modal closed
    setTimeout(() => {
      document.getElementById('manage_dropdown_leftshift')?.focus();
    }, 1000)
  }
  const customFilter = (option, rawInput) => {
    const inputValue = rawInput?.toLowerCase()?.replace(/\./g, ''); // Remove all dots from the search input
    const label = option.label?.toLowerCase()?.replace(/\./g, ''); // Remove all dots from the option label
    return label?.includes(inputValue);
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? <MdOutlineArrowDropUp /> : <MdOutlineArrowDropDown />}
      </components.DropdownIndicator>
    );
  };

  // Done for prefilling values in predictor cases.
  const PrefillDataForUrls = () => {
    Prefill_Fields?.filter((obj) => {
      if(window.location.href?.includes(obj.url)){
        if(name == "target_year" && values.education_level?.id === 22 && obj?.id == 22){
          props.setFormikValues((prev) => ({ ...prev, "target_year":  dropdownDatas?.[0]}));
        }
      }
    })
  }
  
  return (
    <div className="careers_register_select_card">
      {deviceType == "web" &&
        <>
          <CustomSelect
            name={props.name}
            backspaceRemovesValue={false}
            placeholder={!searchBar?? 'Search...'}
            options={dropdownDatas}
            onBlur={handleBlur(name)}
            components={!searchBar&&{ DropdownIndicator: DropdownIndicator }}
            onFocus={(e, item) => props.handleOnFocus(e, props.name, item)}
            getOptionLabel={(opt) => name == "target_year" ? `Targeting ${opt.label} College Admissions` : opt.label ? opt.label : opt.value}
            getOptionValue={(opt) => opt.id || opt.domain_id}
            value={props.values?.[props?.name] ? props.values?.[props?.name] : ""}
            errors={(errors[name] && touched[name])}
            onChange={(option) => {
              if(props.domain?.id == 2 && name === "education_interest"){
                props.areaOfInterestApiCall(undefined, undefined, option); //area of interest api call
                if(props.isUpdateProfile){
                props.postUpdateProfileOnChange(undefined, undefined, option?.domain_id, undefined, false);
                }
              }
              if(props.domain?.id == 2 && name === "certificate_interest"){
                props.areaOfInterestApiCall(undefined, undefined, undefined, option);
                if(props.isUpdateProfile){
                props.postUpdateProfileOnChange(undefined, undefined, undefined, option?.domain_id, false);
                }
              }
              if(name === "school_board"){
                if(!props.isUpdateProfile){
                  if(completeProfileUrl){
                    props.signupDataPost("save",undefined,undefined,undefined,undefined,option)
                  }
                }
              }
              props.setFieldValue(props.name, option);
            }}
            onInputChange={(value, { action }) => {
              if (action === 'input-change') {
                setSearchData(value);
              } else {
                setSearchData(false);
              }
            }}
            noOptionsMessage={({ inputValue }) =>
              (props.passing_year_loading || props.degreePursuingLoading || props.aspiringStreamLoading
                || props.workExperienceLoading || props.targetYearLoading || props.certificateInterestLoading) ? (
                <Loading /> // You can replace this with your custom loader message
              ) : (
                "No options found"
              )
            }
            isSearchable={name === "degree_pursue" ? true : false}
            filterOption={(option, inputValue) => {
              if (name === "degree_pursue") {
                return customFilter(option, inputValue);
              } else {
                return true;
              }
            }}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "#ccc",
                background: state.isFocused || values[name] || (errors[name] && touched[name]) ? '#fff' : '#F8F8F8',
                borderRadius: "3px",
                height: "42px",
                boxShadow: "none",
                border: (errors[name] && touched[name] && !state.menuIsOpen) && '1px solid #b3261e',
                ":hover": {
                  borderColor: (errors[name] && touched[name] && !state.menuIsOpen) ?'#b3261e': "#ccc",
                },
              }),
              valueContainer: (base, state) => ({
                ...base,
                padding: "5px 8px 14px 10px",
                // overflow: "visible",
              }),
              option: (base, state) => ({
                ...base,
                background: state.isSelected || state.isFocused ? 'rgba(0, 0, 0, 0.04);' : '#fff',
                cursor: 'pointer',
                color: '#111',
                ":hover": {
                  background: "rgba(0, 0, 0, 0.04) !important",
                }
              }),
              dropdownIndicator: (provided, state) => ({
                ...provided,
                color: state.isFocused ? "#999" : "#999",
                fontSize: "24px",
                position:'relative',
                bottom:'8px',
                display: (searchBar)&&'none',
                ":hover": {
                  borderColor: "#999"
                }
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display: 'none',
              }),
              menu: (base, state) => ({
                ...base,
                marginTop:"4px",
            }),
              menuList: (base) => ({
                ...base,
                "::-webkit-scrollbar": {
                  width: "4px",
                  height: "0px",
                },
                "::-webkit-scrollbar-track": {
                  background: "#F1F1F1"
                },
                "::-webkit-scrollbar-thumb": {
                  background: "#999"
                },
                "::-webkit-scrollbar-thumb:hover": {
                  background: "#555"
                },
              }),
            }}
            label={'label'}
          />
          <span className={values[name] || searchData ? 'floating_label_active' : 'floating_label'}>{props.placeholder}</span>
        </>
      }

      {deviceType == "mobile" &&
        <div className={(errors[name] && touched[name] && !values[name] && !show) ? "careers_register_form_card invalid_field" : values[name] ? "careers_register_form_card white_bg" : "careers_register_form_card"}
        onClick={(e, item) => {
          setShow(true);
          // props.handleOnFocus(e, name, item);
        }}>
          <Field
            name={name}
            // placeholder={props.placeholder}
            type="text"
            onClick={(e, item) => {
              setShow(true);
              props.handleOnFocus(e, name, item);
            }}
            className="input_type_text"
            value={(name == "target_year" && values[name]?.label) ? `Targeting ${values[name]?.label} College Admissions`
              : (values[name]?.label || values[name]?.value) ? values[name]?.label || values[name]?.value : ""}
            onFocus={() => {
              handleFocus;
            }}
            onBlur = {(e) => {
              if(props.domain?.id == 2 && name === "education_interest" && values[name] && !show){
                props.areaOfInterestApiCall(undefined, undefined, values[name], undefined); //area of interest api call
                if(props.isUpdateProfile){
                props.postUpdateProfileOnChange(undefined, undefined, values[name]?.domain_id, undefined, false);
                }
              }
              if(props.domain?.id == 2 && name === "certificate_interest" && values[name] && !show){
                props.areaOfInterestApiCall(undefined, undefined, undefined, values[name]); //area of interest api call 
                if(props.isUpdateProfile){
                props.postUpdateProfileOnChange(undefined, undefined, undefined, values[name]?.domain_id, false);
                }
              }
            }}
            readOnly
          />
          <span className={values[name] ? 'floating_label_active' : 'floating_label'}>{props.placeholder}</span>
          <div className='custom_Select_indicator_wap'>
            {show ? <MdOutlineArrowDropUp /> : <MdOutlineArrowDropDown />}</div>
        </div>
      }

      <CommonModal
        isOpen={show}
        closeModal={() => {
          setShow(false);
          handleCloseModal();
          props.setTouched({
            ...props.touched,[name]:true
          })
        }}
        showCloseIcon
        classNames={{
          root: searchBar ? 'mobile_modal mobile_modal_height' : 'mobile_modal',
          modal: 'custom_modal',
          modalAnimationIn: 'customEnterModalAnimation',
          modalAnimationOut: 'customLeaveModalAnimation',
        }}
        animationDuration={800}
      >
        <span className="careers_register_dropdown_heading studying_in"><b>{props.placeholder}</b></span>
        <div className={`inner_studyin_modal`}>
          {deviceType == "mobile" && searchBar ? (
            <>
              <CustomSelect
                menuIsOpen={true}
                backspaceRemovesValue={false}
                name={name}
                placeholder={props.placeholder}
                options={dropdownDatas}
                getOptionLabel={(opt) => opt.label}
                getOptionValue={(opt) => opt.id || opt.domain_id}
                value={props.values?.[props?.name] ? props.values?.[props?.name] : ""}
                errors={(errors[name] && touched[name])}
                onChange={(option) => {
                  props.setFieldValue(props.name, option);
                  handleCloseModal();
                }}
                noOptionsMessage={({ inputValue }) =>
                  (props.passing_year_loading || props.degreePursuingLoading || props.aspiringStreamLoading
                    || props.workExperienceLoading || props.targetYearLoading || props.certificateInterestLoading) ? (
                    <Loading /> // You can replace this with your custom loader message
                  ) : (
                    "No options found"
                  )
                }
                isSearchable={name === "degree_pursue" ? true : false}
                filterOption={(option, inputValue) => {
                  if (name === "degree_pursue") {
                    return customFilter(option, inputValue);
                  } else {
                    return true;
                  }
                }}
                onFocus={(e, item) => {
                  props.updateTouchedFields({ ...touched, [`${name}`]: true })
                  // props.handleOnFocus(e, props.name, item);
                  // handleFocus;
                }}
                // onBlur={
                //   overlayActive ? setOverlayActive(false) : handleBlur(name)
                // }
                styles={{
                  container: (base, state) => {
                    if (!state?.selectProps?.menuIsOpen) {
                      setOptionsSlide(false)
                    }
                    return ({
                      ...base,
                      position: "revert",
                    })
                  },
                  menuList: (base, state) => ({
                    ...base,
                    maxHeight: '350px',
                    padding: '0px',
                  }),
                  menu: (base, state) => {
                    setTimeout(() => setOptionsSlide(true), 100)
                    return ({
                      ...base,
                      position: "relative",
                      bottom: '0px',
                      transition: 'all 1s ease',
                      willChange: 'top',
                      bottom: optionsSlide ? '0px' : '-150px',
                      minWidth: '100%',
                      backgroundColor: '#fff',
                      left: '0px',
                      zIndex: '9',
                      padding: '20px 10px 10px 10px',
                      borderRadius: '20px 20px 0px 0px',
                    })
                  },
                  option: (base, state) => ({
                    ...base,
                    background: state.isSelected ? 'rgba(0, 0, 0, 0.04);' : '#fff',
                    color: '#111',
                  }),
                  control: (base, state) => ({
                    ...base,
                    borderColor: "#ccc",
                    background: state.isFocused || values[name] || (errors[name] && touched[name]) ? '#fff' : '#F8F8F8',
                    borderRadius: "3px",
                    minHeight: "42px",
                    boxShadow: "none",
                    // border:(errors[name] && touched[name]) && '1px solid #b3261e',
                    ":hover": {
                      borderColor: "#ccc",
                    },
                  }),
                  valueContainer: (base, state) => ({
                    ...base,
                    padding: "5px 8px 5px 10px",
                    // overflow: "visible",
                  }),
                }}
                label={'label'}
              />
            </>
          ) : (
            <div className="careers_radio_group">
              {(props.passing_year_loading || props.degreePursuingLoading || props.aspiringStreamLoading
                || props.workExperienceLoading || props.targetYearLoading || props.certificateInterestLoading) ? <Loading /> : (
                <> 
                  {
                    Object.keys(dropdownDatas)?.map((key) => (
                      <div className="group_item" key={key}>
                        <h5 className={dropdownDatas[key].label === values[name]?.label ? 'selected_data':''}
                          onClick={(e) => {
                            props.setFieldValue(name, dropdownDatas[key]);
                             handleCloseModal();
                          }}
                        >{name == "target_year" ? `Targeting ${dropdownDatas[key]?.label} College Admissions` : dropdownDatas[key]?.label ? dropdownDatas[key]?.label : ""}</h5>
                        <div className="careers_list_item">
                          {Array.isArray(dropdownDatas[key]?.options)
                            ? dropdownDatas[key]?.options?.map((listItem) => (
                              <label key={listItem.id} htmlFor={listItem.id}>
                                <span className="design"></span>
                                <span className="text"
                                  onClick={(e) => { props.setFieldValue(name, listItem); handleCloseModal() }}
                                > {listItem.label}</span>
                              </label>
                            ))
                            : typeof dropdownDatas[key] === 'object' &&
                            Object.keys(dropdownDatas[key])?.map((subKey) => (
                              Array.isArray(dropdownDatas[key][subKey])
                                ? dropdownDatas[key][subKey]?.map((listItem) => (
                                  <label key={listItem.id} htmlFor={listItem.id}>
                                    <span className="design"></span>
                                    <span className="text"
                                      onClick={(e) => { props.setFieldValue(name, listItem); handleCloseModal() }}
                                    >{listItem.label}</span>
                                  </label>
                                ))
                                : null
                            ))}
                        </div>
                      </div>
                    ))}
                </>
              )}
            </div>
          )
          }
        </div>
      </CommonModal>

      {
        errors[name] && touched[name] && !values[name] && !show && (
          <div className="invalid_card">
            <span className="invalid_card_text">{errors[name]}</span>
          </div>
        )
      }
      {overlayActive && <div className="overlayMobile"></div>}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    passing_year_loading: state.userSignUpFields.passingYearLoading,
    degreePursuingLoading: state.userSignUpFields.degreePursuingLoading,
    aspiringStreamLoading: state.userSignUpFields.aspiringStreamLoading,
    workExperienceLoading: state.userSignUpFields.workExperienceLoading,
    targetYearLoading: state.userSignUpFields.targetYearLoading,
    certificateInterestLoading: state.userSignUpFields.certificateInterestLoading,

  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareersRegisterSingleSelect);